<template>
    <div class="neural-computer"
        :class="direction == 'horizontal' ? 'neural-computer-bg-horizontal' : 'neural-computer-bg-vertical'"
        v-dragscroll:firstchilddrag.auto="{ active: true, target: '.neural-computer-wrap',ignoreChild: ['computer-map-cell','skill'] }">
        <div class="neural-computer-wrap" :class="direction">
            <div id="computer-map" class="computer-map" :class="mapType">
                <div class="computer-map-cell" :id="`computer-map-cell${index}`"
                    v-for="(item, index) in mapCellData[cellType] || []" :key="index"
                    @click.stop="handleClickCell(index, item.type == 'RECT')"
                    :style="{ width: item.size.width, height: item.size.height, left: `${item.position.x}rem`, top: `${item.position.y}rem` }">
                    <img v-if="item.type == 'SKILL' || item.type == 'OCCUPATION'"
                        :class="item.type == 'SKILL' || item.type == 'OCCUPATION' ? item.type.toLowerCase() : ''"
                        :src="getImgSrc(index)" />
                </div>
                <toolTip v-clickoutside="removeAll" :show="showToolTip" :position="toolTipPosition" :toolTipData="toolTipData" :type="toolTipType">
                </toolTip>
            </div>
        </div>
    </div>
</template>

<script>
import dragscroll from '../directive/dragable.js'
import clickoutside from '../directive/clickOutSide.js'
import toolTip from './base/toolTip.vue'
const cellSizeEnum = {
    LITTLE: {
        width: '.3rem',
        height: '.3rem'
    },
    RECT: {
        width: '1.77rem',
        height: '.33rem'
    },
    SKILL: {
        width: '.6rem',
        height: '.6rem'
    },
    AREA: {
        width: '.69rem',
        height: '.69rem'
    },
    OCCUPATION: {
        width: '.85rem',
        height: '.85rem'
    }
}
export default {
    directives: {
        clickoutside,
        dragscroll
    },
    components: {
        toolTip
    },
    props: {
        direction: {
            type: String,
            default: 'horizontal'  //horizontal||vertical
        },
        originData: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            mapCellData: {
                type1: [ //横向26
                    { id: 1, type: 'OCCUPATION', position: { x: 0.22, y: 1.71 }, size: cellSizeEnum.OCCUPATION },//0.51 ,1.6  
                    { id: 2, type: 'SKILL', position: { x: 1.6, y: 1.84 }, size: cellSizeEnum.SKILL },
                    { id: 3, type: 'LITTLE', position: { x: 2.63, y: 2.03 }, size: cellSizeEnum.LITTLE },
                    { id: 4, type: 'AREA', position: { x: 3.44, y: 1.8 }, size: cellSizeEnum.AREA },
                    { id: 5, type: 'LITTLE', position: { x: 3.62, y: 3 }, size: cellSizeEnum.LITTLE },
                    { id: 6, type: 'SKILL', position: { x: 4.48, y: 3.61 }, size: cellSizeEnum.SKILL },
                    { id: 7, type: 'LITTLE', position: { x: 4.63, y: 2.03 }, size: cellSizeEnum.LITTLE },
                    { id: 8, type: 'SKILL', position: { x: 5.29, y: 1.83 }, size: cellSizeEnum.SKILL },
                    { id: 9, type: 'LITTLE', position: { x: 5.43, y: 1.05 }, size: cellSizeEnum.LITTLE },
                    { id: 10, type: 'SKILL', position: { x: 5.29, y: 0.05 }, size: cellSizeEnum.SKILL },
                    { id: 11, type: 'LITTLE', position: { x: 6.42, y: 2.03 }, size: cellSizeEnum.LITTLE },
                    { id: 12, type: 'AREA', position: { x: 7.52, y: 1.8 }, size: cellSizeEnum.AREA },
                    { id: 13, type: 'LITTLE', position: { x: 7.7, y: 3 }, size: cellSizeEnum.LITTLE },
                    { id: 14, type: 'SKILL', position: { x: 7.55, y: 3.62 }, size: cellSizeEnum.SKILL },
                    { id: 15, type: 'LITTLE', position: { x: 8.72, y: 2.03 }, size: cellSizeEnum.LITTLE },
                    { id: 16, type: 'AREA', position: { x: 9.5, y: 1.8 }, size: cellSizeEnum.AREA },
                    { id: 17, type: 'LITTLE', position: { x: 9.67, y: 1.05 }, size: cellSizeEnum.LITTLE },
                    { id: 18, type: 'RECT', position: { x: 11.4, y: 0.23 }, size: cellSizeEnum.RECT },
                    { id: 19, type: 'LITTLE', position: { x: 10.67, y: 2.03 }, size: cellSizeEnum.LITTLE },
                    { id: 20, type: 'RECT', position: { x: 11.46, y: 2.03 }, size: cellSizeEnum.RECT },
                    { id: 21, type: 'LITTLE', position: { x: 11.65, y: 3 }, size: cellSizeEnum.LITTLE },
                    { id: 22, type: 'RECT', position: { x: 11.44, y: 3.76 }, size: cellSizeEnum.RECT },
                    { id: 23, type: 'LITTLE', position: { x: 13.47, y: 2.03 }, size: cellSizeEnum.LITTLE },
                    { id: 24, type: 'RECT', position: { x: 14.12, y: 2.03 }, size: cellSizeEnum.RECT },
                    { id: 25, type: 'LITTLE', position: { x: 16.27, y: 2.03 }, size: cellSizeEnum.LITTLE },
                    { id: 26, type: 'RECT', position: { x: 16.94, y: 2.03 }, size: cellSizeEnum.RECT },
                ],
                type2: [//横向36
                    { id: 1, type: 'OCCUPATION', position: { x: 0.25, y: 1.82 }, size: cellSizeEnum.OCCUPATION }, //0.25,1.82 x: 0.76, y: 2.07   -0.51,0.25
                    { id: 2, type: 'SKILL', position: { x: 1.69, y: 1.95 }, size: cellSizeEnum.SKILL },
                    { id: 3, type: 'LITTLE', position: { x: 2.79, y: 2.12 }, size: cellSizeEnum.LITTLE },
                    { id: 4, type: 'AREA', position: { x: 3.65, y: 1.89 }, size: cellSizeEnum.AREA },
                    { id: 5, type: 'LITTLE', position: { x: 3.84, y: 3.16 }, size: cellSizeEnum.LITTLE },
                    { id: 6, type: 'SKILL', position: { x: 3.69, y: 3.82 }, size: cellSizeEnum.SKILL },
                    { id: 7, type: 'LITTLE', position: { x: 4.89, y: 2.13 }, size: cellSizeEnum.LITTLE },
                    { id: 8, type: 'SKILL', position: { x: 5.59, y: 1.95 }, size: cellSizeEnum.SKILL },
                    { id: 9, type: 'LITTLE', position: { x: 5.74, y: 1.1 }, size: cellSizeEnum.LITTLE },
                    { id: 10, type: 'SKILL', position: { x: 5.58, y: 0.1 }, size: cellSizeEnum.SKILL },
                    { id: 11, type: 'LITTLE', position: { x: 6.78, y: 2.13 }, size: cellSizeEnum.LITTLE },
                    { id: 12, type: 'AREA', position: { x: 7.81, y: 1.89 }, size: cellSizeEnum.AREA },
                    { id: 13, type: 'LITTLE', position: { x: 8.32, y: 3.16 }, size: cellSizeEnum.LITTLE },
                    { id: 14, type: 'SKILL', position: { x: 8.18, y: 3.82 }, size: cellSizeEnum.SKILL },
                    { id: 15, type: 'LITTLE', position: { x: 9.09, y: 2.12 }, size: cellSizeEnum.LITTLE },
                    { id: 16, type: 'AREA', position: { x: 10.14, y: 1.89 }, size: cellSizeEnum.AREA },
                    { id: 17, type: 'LITTLE', position: { x: 10.33, y: 1.1 }, size: cellSizeEnum.LITTLE },
                    { id: 18, type: 'RECT', position: { x: 9.95, y: 0.24 }, size: cellSizeEnum.RECT },
                    { id: 19, type: 'LITTLE', position: { x: 10.33, y: 3.15 }, size: cellSizeEnum.LITTLE },
                    { id: 20, type: 'RECT', position: { x: 9.94, y: 3.9 }, size: cellSizeEnum.RECT },
                    { id: 21, type: 'LITTLE', position: { x: 11.32, y: 2.13 }, size: cellSizeEnum.LITTLE },
                    { id: 22, type: 'SKILL', position: { x: 12.29, y: 1.98 }, size: cellSizeEnum.SKILL },
                    { id: 23, type: 'LITTLE', position: { x: 12.41, y: 1.1 }, size: cellSizeEnum.LITTLE },
                    { id: 24, type: 'RECT', position: { x: 12.15, y: 0.24 }, size: cellSizeEnum.RECT },
                    { id: 25, type: 'LITTLE', position: { x: 12.41, y: 3.15 }, size: cellSizeEnum.LITTLE },
                    { id: 26, type: 'RECT', position: { x: 12.06, y: 3.9 }, size: cellSizeEnum.RECT },
                    { id: 27, type: 'LITTLE', position: { x: 13.3, y: 2.13 }, size: cellSizeEnum.LITTLE },
                    { id: 28, type: 'AREA', position: { x: 14.26, y: 1.92 }, size: cellSizeEnum.AREA },
                    { id: 29, type: 'LITTLE', position: { x: 14.38, y: 3.14 }, size: cellSizeEnum.LITTLE },
                    { id: 30, type: 'RECT', position: { x: 15.05, y: 3.1 }, size: cellSizeEnum.RECT },
                    { id: 31, type: 'LITTLE', position: { x: 15.41, y: 2.14 }, size: cellSizeEnum.LITTLE },
                    { id: 32, type: 'SKILL', position: { x: 16.14, y: 1.95 }, size: cellSizeEnum.SKILL },
                    { id: 33, type: 'LITTLE', position: { x: 16.28, y: 1.12 }, size: cellSizeEnum.LITTLE },
                    { id: 34, type: 'RECT', position: { x: 17.02, y: 1.12 }, size: cellSizeEnum.RECT },
                    { id: 35, type: 'LITTLE', position: { x: 17.26, y: 2.13 }, size: cellSizeEnum.LITTLE },
                    { id: 36, type: 'RECT', position: { x: 18.04, y: 2.14 }, size: cellSizeEnum.RECT },
                ],
                type1Ver: [//竖向26
                    { id: 1, type: 'OCCUPATION', position: { x: 2.74, y: 0.27 }, size: cellSizeEnum.OCCUPATION },
                    { id: 2, type: 'SKILL', position: { x: 2.87, y: 1.76 }, size: cellSizeEnum.SKILL },
                    { id: 3, type: 'LITTLE', position: { x: 2.99, y: 2.88 }, size: cellSizeEnum.LITTLE },
                    { id: 4, type: 'AREA', position: { x: 2.8, y: 3.77 }, size: cellSizeEnum.AREA },
                    { id: 5, type: 'LITTLE', position: { x: 1.93, y: 3.95 }, size: cellSizeEnum.LITTLE },
                    { id: 6, type: 'SKILL', position: { x: 0.95, y: 4.89 }, size: cellSizeEnum.SKILL },
                    { id: 7, type: 'LITTLE', position: { x: 2.99, y: 5.04 }, size: cellSizeEnum.LITTLE },
                    { id: 8, type: 'SKILL', position: { x: 2.87, y: 5.76 }, size: cellSizeEnum.SKILL },
                    { id: 9, type: 'LITTLE', position: { x: 4.04, y: 5.92 }, size: cellSizeEnum.LITTLE },
                    { id: 10, type: 'SKILL', position: { x: 4.77, y: 5.76 }, size: cellSizeEnum.SKILL },
                    { id: 11, type: 'LITTLE', position: { x: 2.99, y: 6.98 }, size: cellSizeEnum.LITTLE },
                    { id: 12, type: 'AREA', position: { x: 2.83, y: 8.21 }, size: cellSizeEnum.AREA },
                    { id: 13, type: 'LITTLE', position: { x: 1.93, y: 8.36 }, size: cellSizeEnum.LITTLE },
                    { id: 14, type: 'SKILL', position: { x: 0.94, y: 8.21 }, size: cellSizeEnum.SKILL },
                    { id: 15, type: 'LITTLE', position: { x: 2.99, y: 9.47 }, size: cellSizeEnum.LITTLE },
                    { id: 16, type: 'AREA', position: { x: 2.85, y: 10.35 }, size: cellSizeEnum.AREA },
                    { id: 17, type: 'LITTLE', position: { x: 4.04, y: 10.51 }, size: cellSizeEnum.LITTLE },
                    { id: 18, type: 'RECT', position: { x: 4.35, y: 12.63 }, size: cellSizeEnum.RECT },
                    { id: 19, type: 'LITTLE', position: { x: 2.99, y: 11.6 }, size: cellSizeEnum.LITTLE },
                    { id: 20, type: 'RECT', position: { x: 2.4, y: 12.62 }, size: cellSizeEnum.RECT },
                    { id: 21, type: 'LITTLE', position: { x: 1.93, y: 12.65 }, size: cellSizeEnum.LITTLE },
                    { id: 22, type: 'RECT', position: { x: 0.03, y: 12.65 }, size: cellSizeEnum.RECT },
                    { id: 23, type: 'LITTLE', position: { x: 2.99, y: 13.61 }, size: cellSizeEnum.LITTLE },
                    { id: 24, type: 'RECT', position: { x: 2.24, y: 14.35 }, size: cellSizeEnum.RECT },
                    { id: 25, type: 'LITTLE', position: { x: 2.99, y: 15.14 }, size: cellSizeEnum.LITTLE },
                    { id: 26, type: 'RECT', position: { x: 2.24, y: 15.9 }, size: cellSizeEnum.RECT },
                ],
                type2Ver: [//竖向36
                    { id: 1, type: 'OCCUPATION', position: { x: 2.6, y: 0.24 }, size: cellSizeEnum.OCCUPATION },
                    { id: 2, type: 'SKILL', position: { x: 2.72, y: 1.66 }, size: cellSizeEnum.SKILL },
                    { id: 3, type: 'LITTLE', position: { x: 2.86, y: 2.74 }, size: cellSizeEnum.LITTLE },
                    { id: 4, type: 'AREA', position: { x: 2.7, y: 3.58 }, size: cellSizeEnum.AREA },
                    { id: 5, type: 'LITTLE', position: { x: 1.85, y: 3.78 }, size: cellSizeEnum.LITTLE },
                    { id: 6, type: 'SKILL', position: { x: 0.9, y: 3.62 }, size: cellSizeEnum.SKILL },
                    { id: 7, type: 'LITTLE', position: { x: 2.86, y: 4.82 }, size: cellSizeEnum.LITTLE },
                    { id: 8, type: 'SKILL', position: { x: 2.72, y: 5.5 }, size: cellSizeEnum.SKILL },
                    { id: 9, type: 'LITTLE', position: { x: 3.86, y: 5.65 }, size: cellSizeEnum.LITTLE },
                    { id: 10, type: 'SKILL', position: { x: 4.58, y: 5.5 }, size: cellSizeEnum.SKILL },
                    { id: 11, type: 'LITTLE', position: { x: 2.86, y: 6.68 }, size: cellSizeEnum.LITTLE },
                    { id: 12, type: 'AREA', position: { x: 2.7, y: 7.72 }, size: cellSizeEnum.AREA },
                    { id: 13, type: 'LITTLE', position: { x: 1.85, y: 8.21 }, size: cellSizeEnum.LITTLE },
                    { id: 14, type: 'SKILL', position: { x: 0.7, y: 8.05 }, size: cellSizeEnum.SKILL },
                    { id: 15, type: 'LITTLE', position: { x: 2.86, y: 8.95 }, size: cellSizeEnum.LITTLE },
                    { id: 16, type: 'AREA', position: { x: 2.66, y: 10 }, size: cellSizeEnum.AREA },
                    { id: 17, type: 'LITTLE', position: { x: 3.87, y: 10.18 }, size: cellSizeEnum.LITTLE },
                    { id: 18, type: 'RECT', position: { x: 4.34, y: 10.16 }, size: cellSizeEnum.RECT },
                    { id: 19, type: 'LITTLE', position: { x: 1.85, y: 10.19 }, size: cellSizeEnum.LITTLE },
                    { id: 20, type: 'RECT', position: { x: 0, y: 10.18 }, size: cellSizeEnum.RECT },
                    { id: 21, type: 'LITTLE', position: { x: 2.86, y: 11.15 }, size: cellSizeEnum.LITTLE },
                    { id: 22, type: 'SKILL', position: { x: 2.72, y: 12.11 }, size: cellSizeEnum.SKILL },
                    { id: 23, type: 'LITTLE', position: { x: 3.87, y: 12.22 }, size: cellSizeEnum.LITTLE },
                    { id: 24, type: 'RECT', position: { x: 4.32, y: 12.22 }, size: cellSizeEnum.RECT },
                    { id: 25, type: 'LITTLE', position: { x: 1.85, y: 12.25 }, size: cellSizeEnum.LITTLE },
                    { id: 26, type: 'RECT', position: { x: 0, y: 12.25 }, size: cellSizeEnum.RECT },
                    { id: 27, type: 'LITTLE', position: { x: 2.86, y: 13.05 }, size: cellSizeEnum.LITTLE },
                    { id: 28, type: 'AREA', position: { x: 2.7, y: 13.95 }, size: cellSizeEnum.AREA },
                    { id: 29, type: 'LITTLE', position: { x: 1.1, y: 13.98 }, size: cellSizeEnum.LITTLE },
                    { id: 30, type: 'RECT', position: { x: 0.3, y: 14.74 }, size: cellSizeEnum.RECT },
                    { id: 31, type: 'LITTLE', position: { x: 2.86, y: 15.21 }, size: cellSizeEnum.LITTLE },
                    { id: 32, type: 'SKILL', position: { x: 2.72, y: 15.93 }, size: cellSizeEnum.SKILL },
                    { id: 33, type: 'LITTLE', position: { x: 3.86, y: 16.07 }, size: cellSizeEnum.LITTLE },
                    { id: 34, type: 'RECT', position: { x: 4.3, y: 16.07 }, size: cellSizeEnum.RECT },
                    { id: 35, type: 'LITTLE', position: { x: 2.86, y: 17.05 }, size: cellSizeEnum.LITTLE },
                    { id: 36, type: 'RECT', position: { x: 2.15, y: 17.79 }, size: cellSizeEnum.RECT },
                ],

            },
            showToolTip: false,
            toolTipType: 'normal',
            toolTipData: {
                title: '職業能力解锁',
                desc: '<span>主动攻擊时有概率使用对侧手臂发动<span>[追击]</span>，造成<span style="color=#F74848">0.5</span>倍伤害；目标每携带<span style="color=#F74848">1</span>层<span>[失稳Ⅱ]</span>，概率增加<span style="color:#F74848">10%</span>，[追击]后对目标额外施加<span style="color:#F74848">1</span>层[失稳Ⅱ]</span>'
            },
            toolTipPosition: {
                x: 0,
                y: 0
            },
        }
    },
    computed: {
        mapType() {
            if (this.originData && this.originData.neuralComputer) {
                if (this.originData.neuralComputer.type == 1) { //26格
                    return this.direction == 'horizontal' ? 'computer-map-type1' : 'computer-map-type1-ver'
                } else { //36格
                    return this.direction == 'horizontal' ? 'computer-map-type2' : 'computer-map-type2-ver'
                }
            } else {
                return ''
            }
        },
        cellType() {
            if (this.originData && this.originData.neuralComputer) {
                if (this.originData.neuralComputer.type == 1) {
                    return this.direction == 'horizontal' ? 'type1' : 'type1Ver'
                } else {
                    return this.direction == 'horizontal' ? 'type2' : 'type2Ver'
                }
            } else {
                return 'loading'
            }
        },
        mapData() {
            return this.originData.neuralComputer.data
        }
    },
    methods: {
        getImgSrc(index) {
            let cellData = this.mapData.find(item => item.id == index)
            return cellData ? cellData.src : ''
        },
        handleClickCell(index, isSmallBorder) {
            let cellData = this.mapData.find(item => item.id == index)
            let isSkillTip = cellData.type == '2'
            this.toolTipData = cellData
            this.toolTipType = isSkillTip ? 'skill' : 'normal'
            this.showToolTip = true
            this.$nextTick(() => {
                let tipPos = this.genTipPosition(index, isSkillTip)
                this.toolTipPosition.x = tipPos.x
                this.toolTipPosition.y = tipPos.y
            })


            //移除所有class为compuer-map-cell元素的active
            let cells = document.querySelectorAll('.computer-map-cell')
            cells.forEach(item => {
                item.classList.remove('active2')
                item.classList.remove('active')
            })
            //给当前点击的cell添加active
            let cell = document.getElementById(`computer-map-cell${index}`)
            if (cell) {
                cell.classList.add(isSmallBorder ? 'active2' : 'active')
            }
        },
        genTipPosition(index) {
            let rem = this.getRem()
            let parent = document.getElementById("computer-map");   // 获取父元素
            let child = document.getElementById(`computer-map-cell${index}`);     // 获取子元素

            let popupel = document.getElementById('game-info-tool-tip')     // 获取浮层
            let popup = { offsetWidth: popupel.offsetWidth, offsetHeight: popupel.offsetHeight }     // 获取浮层

            let parentWidth = parent.offsetWidth;            // 获取父元素的宽度
            let parentHeight = parent.offsetHeight;          // 获取父元素的高度
            let popupWidth = popup.offsetWidth;              // 获取浮层的宽度
            let popupHeight = popup.offsetHeight;            // 获取浮层的高度

            let offsetParent = child.offsetParent;             // 获取最近的定位祖先元素
            let top = child.offsetTop - offsetParent.offsetTop;  // 计算子元素相对于offsetParent的top值
            let left = child.offsetLeft - offsetParent.offsetLeft;  // 计算子元素相对于offsetParent的left值

            // 计算浮层的位置
            let popupTop = this.direction === 'horizontal' ? top + child.offsetHeight : top + 1.5 * rem;
            let popupLeft = this.direction === 'horizontal' ? left + 1.5 * rem : left - popupWidth / 2 + child.offsetWidth / 2;

            // 判断浮层是否超出父元素的边界，并进行调整
            if (this.direction === 'horizontal') {
                if (popupHeight >= parentHeight) {
                    popupHeight = parentHeight / 2
                } else if (popupTop - popupHeight < 0 && popupTop + popupHeight > parentHeight) {
                    popupHeight = parentHeight / 2
                }
                else if (popupTop - popupHeight < 0) {
                    popupTop = top + popupHeight / 2;
                }
                else if (popupTop + popupHeight > parentHeight) {
                    popupTop = top - popupHeight / 2;
                }
                if (popupLeft + popupWidth > parentWidth) {
                    popupLeft = left - (popupWidth / 2 + 1.5 * rem);
                }
            } else {
                if (popupTop + popupHeight > parentHeight) {
                    popupTop = top - popupHeight / 2;
                }
                if (popupLeft + popupWidth > parentWidth) {
                    popupLeft = left - (popupWidth / 2);
                }
                if (popupLeft < 0) {
                    popupLeft = 0
                }
            }

            return {
                x: popupLeft,
                y: popupTop
            }
        },
        getRem() {
            let width = 750;
            let dw = document.documentElement.clientWidth;
            let _zoom = dw / width * 100;
            _zoom = _zoom > 70 ? 70 : _zoom;
            return _zoom;
        },
        removeAll() {
            this.showToolTip = false
            let cells = document.querySelectorAll('.computer-map-cell')
            cells.forEach(item => {
                item.classList.remove('active2')
                item.classList.remove('active')
            })
        },
        closePanel() {
            console.log('close')
        }
    }
}
</script>

<style scoped lang="scss">
.neural-computer {
    position: relative;
    margin: 0 auto;
    display: flex;

    ::-webkit-scrollbar {
        -webkit-appearance: none;
    }

    ::-webkit-scrollbar:vertical {
        width: .06rem;
    }

    ::-webkit-scrollbar:horizontal {
        height: .06rem;
    }

    ::-webkit-scrollbar-thumb {
        background-color: #d35255;
        border: 0px solid #d35255;
    }

    ::-webkit-scrollbar-track {
        background-color: #585960;
    }


    &-wrap {
        position: relative;

        .computer-map {
            flex-shrink: 0;
            position: relative;

            &-cell {
                position: absolute;
                display: flex;
                align-items: center;
                justify-content: center;

                .occupation {
                    width: .55rem;
                    height: .55rem;
                    object-fit: contain;
                }

                .skill {
                    width: .4rem;
                    height: .4rem;
                    object-fit: contain;
                }

                &.active::after {
                    width: 160%;
                    height: 160%;
                    content: '';
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    border: .02rem solid #fffaad;
                }

                &.active2::after {
                    width: 105%;
                    height: 120%;
                    content: '';
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    border: .02rem solid #fffaad;
                }

                img {
                    user-select: none;
                }
            }
        }

        &.horizontal {
            width: 100%;
            padding: 0 .5rem;
            height: calc(100% - .06rem);
            overflow-y: hidden;
            overflow-x: auto;
            display: flex;
            align-items: center;
            justify-content: flex-start;


        }

        &.vertical {
            height: 100%;
            padding: .5rem 0;
            width: calc(100% - .06rem);
            overflow-y: auto;
            overflow-x: hidden;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-start;
        }
    }

    &.neural-computer-bg-horizontal {
        align-items: center;
        justify-content: flex-start;
    }

    &.neural-computer-bg-vertical {
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
    }
}
</style>